import { Button } from "design-system/atoms/Button"
import { Download } from "lucide-react"
import { cloneElement, ReactElement, useRef } from "react"
import { useTranslation } from "react-i18next"
import { generateQRUrl } from "./generateQRURL"

type DownloadQRImageProps = {
  qrId?: string | null
  qrName?: string | null
  companyId?: string | null
  children?: ReactElement<{ onClick?: () => void }>
  className?: string
}

const QR_SIZE = 512

export const DownloadQRImage = ({
  qrId,
  qrName,
  companyId,
  children,
  className,
}: DownloadQRImageProps) => {
  const qrCode = useRef(null)
  const { t } = useTranslation()
  const url = generateQRUrl(qrId, companyId)
  const qrCodeImage = `https://api.qrserver.com/v1/create-qr-code/?data=${encodeURIComponent(
    url,
  )}&size=${QR_SIZE}x${QR_SIZE}&margin=20`

  const onClickDownload = async () => {
    const image = await fetch(qrCodeImage)
    const imageBlog = await image.blob()
    const imageURL = URL.createObjectURL(imageBlog)

    const link = document.createElement("a")
    link.href = imageURL
    link.download = qrName || "QR"
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  return (
    <>
      <div className="fixed -left-[9999px] -top-[9999px]">
        <a ref={qrCode} href={qrCodeImage} download="test" />
      </div>
      {children ? (
        cloneElement(children, { onClick: onClickDownload })
      ) : (
        <Button type="button" onClick={onClickDownload} className={className}>
          <Download size={16} />
          <span>{t("campaigns.templates.qr.detail.download")}</span>
        </Button>
      )}
    </>
  )
}
